// Source of truth for the Live Analytics agent's special-domain set.

const DECISION_RESULT_PALETTE = [
  "#10B981", // green-500   → pass
  "#EF4444", // red-500     → fail
  "#F97316", // orange-500  → error
] as const;

const ENVIRONMENT_PALETTE = [
  "#10B981", // green-500  → live
  "#F59E0B", // yellow-500 → sandbox
] as const;

const CATEGORICAL_PALETTE = [
  "#6A63F1", // indigo-500
  "#10B981", // green-500
  "#F97316", // orange-500
  "#EC4899", // pink-500
  "#F59E0B", // yellow-500
  "#373D51", // gray-700
] as const;

export type SpecialDomain = {
  palette: readonly string[];
  // Not used by unbounded domains.
  values?: readonly string[];
  description: string;
};

export const SPECIAL_DOMAINS: Record<string, SpecialDomain> = {
  decision_result: {
    palette: DECISION_RESULT_PALETTE,
    values: ["pass", "fail", "error"],
    description:
      "Use when the column carries the outcome of a decision. CAST the SQL column to one of the allowed values so the chart reads pass=green, fail=red, error=orange.",
  },
  environment: {
    palette: ENVIRONMENT_PALETTE,
    values: ["live", "sandbox"],
    description:
      "Use when the column carries the workspace environment. CAST to one of the allowed values so the chart reads live=green, sandbox=yellow.",
  },
  flow_id: {
    palette: CATEGORICAL_PALETTE,
    description:
      "Use when the column is a flow identifier. The same flow reads as the same color across every chart.",
  },
  flow_version_id: {
    palette: CATEGORICAL_PALETTE,
    description:
      "Use when the column is a flow version identifier. The same version reads as the same color across every chart.",
  },
};

// Vega-Lite's top-level `config.font` cascades to most text marks (tick
// labels, legend labels, text marks) but axis titles, legend titles, and
// chart titles inherit through their own font chains, so they need to be
// set explicitly here too.
const APP_FONT = '"Inter Var", "Inter", sans-serif';

const TITLE_FONT_WEIGHT = 500;

export const TAKTILE_CHART_CONFIG = {
  font: APP_FONT,
  axis: {
    labelColor: "#4B5163", // gray-600
    tickColor: "#D1D3DB", // gray-300
    gridColor: "#E5E6EB", // gray-200
    domainColor: "#D1D3DB", // gray-300
    labelFont: APP_FONT,
    titleFont: APP_FONT,
    titleFontWeight: TITLE_FONT_WEIGHT,
  },
  legend: {
    labelFont: APP_FONT,
    titleFont: APP_FONT,
    titleFontWeight: TITLE_FONT_WEIGHT,
  },
  title: {
    font: APP_FONT,
    subtitleFont: APP_FONT,
  },
  header: {
    labelFont: APP_FONT,
    titleFont: APP_FONT,
  },
  mark: {
    font: APP_FONT,
  },
  range: {
    category: CATEGORICAL_PALETTE,
  },
};
